import axios from 'axios';
import { ADMIN_USER_API_PATH, BASE_URL, USER_API_PATH } from 'constants/api';
import { AccountInterface, UserProjectRoleInterface } from '../../type/accountType';
import { ApiService } from './apiService';

class AccountApiService extends ApiService<AccountInterface> {
  public async fetchAccount(): Promise<AccountInterface> {
    const response = await axios.get(`${BASE_URL}${USER_API_PATH}`);
    return response.data;
  }

  public async updateProfile(profile: AccountInterface): Promise<AccountInterface> {
    const response = await axios.patch(`${BASE_URL}${USER_API_PATH}`, profile);
    return response.data;
  }

  public async updatePassword(oldPassword: string, newPassword: string): Promise<AccountInterface> {
    const response = await axios.patch(`${BASE_URL}${USER_API_PATH}password/`, {
      old_password: oldPassword,
      new_password: newPassword,
    });
    return response.data;
  }

  public async getUserProjectRoles(id: number): Promise<UserProjectRoleInterface> {
    const response = await axios.get(`${BASE_URL}${ADMIN_USER_API_PATH}${id}`);
    return response.data;
  }
}

export const accountApiService = new AccountApiService(USER_API_PATH);
